import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "step__subtitle",
  for: "selectedCompanyId"
}
const _hoisted_2 = ["value"]

export interface Company {
        id: string;
        name: string;
        selectable: boolean;
        maltPlusBetaOnly: boolean;
    }

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CompanySelector',
  props: /*@__PURE__*/_mergeModels({
    companies: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

    const selectedCompanyId = _useModel(__props, "modelValue");
    

return (_ctx: any,_cache: any) => {
  const _component_VJoyPanel = _resolveComponent("VJoyPanel")!

  return (_openBlock(), _createBlock(_component_VJoyPanel, { class: "joy-panel" }, {
    "panel-title": _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.form.overview.company.title')), 1)
    ]),
    "panel-body": _withCtx(() => [
      _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$msg('customer.brief.form.overview.company.text')), 1),
      _withDirectives(_createElementVNode("select", {
        id: "selectedCompanyId",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedCompanyId).value = $event)),
        class: "m-select",
        required: "",
        "aria-label": "select-company"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
          return (_openBlock(), _createElementBlock("option", {
            key: company.id,
            value: company.id,
            selected: ""
          }, _toDisplayString(company.name), 9, _hoisted_2))
        }), 128))
      ], 512), [
        [_vModelSelect, selectedCompanyId.value]
      ])
    ]),
    _: 1
  }))
}
}

})